import { currentTraits } from '../input';
import { prefersLargeTargets } from '../input/traits';

/**
 * **触控的最小可点尺寸。**
 *
 * 视觉不动，只把 `hitArea` 往外扩一点 —— 手指不要求“看得见的地方”才点得中。
 * 阈值随输入画像（`prefersLargeTargets`）走，所以鼠标下**一个像素都不改**。
 *
 * ⚠️ 每个方向最多扩 `MAX_HIT_EXPAND` 逻辑像素：扩太多会让相邻控件互相盖住，
 *    那比“小”更糟（点一个触发另一个）。
 */

/** 最小可点尺寸（CSS px）。44 是 iOS HIG / 常见可达性下限 */
export const MIN_TOUCH_CSS = 44;
/** 每个方向最多往外扩多少逻辑像素 */
export const MAX_HIT_EXPAND = 10;

let scaleSource: (() => number) | null = null;

/** 世界缩放从哪来（`screenHost` 把 `layout().scale` 接进来）。没有就按 1 */
export function setUiScaleSource(source: (() => number) | null): void {
  scaleSource = source;
}

export function uiScaleNow(): number {
  const scale = scaleSource?.();
  return scale !== undefined && Number.isFinite(scale) && scale > 0 ? scale : 1;
}

export interface HitSize {
  readonly width: number;
  readonly height: number;
}

/**
 * 计算实际的命中尺寸。`large=false`（鼠标/精确指针）时恒等。
 *
 * 纯函数：`scale` / `large` 可注入，方便在 node 里断言。
 */
export function touchHitSize(
  width: number,
  height: number,
  scale: number = uiScaleNow(),
  large: boolean = prefersLargeTargets(currentTraits()),
): HitSize {
  if (!large) return { width, height };
  const min = MIN_TOUCH_CSS / (scale > 0 ? scale : 1);
  const grow = (value: number): number => Math.max(value, Math.min(value + MAX_HIT_EXPAND * 2, min));
  return { width: grow(width), height: grow(height) };
}
